import { NDateInput, NInput } from '@/uikit';
import { IFormLayout } from '@/uikit/forms/NForm.vue';
import Permissions from '@/components/permissions/deprecated/Permissions.vue';
import { getStringLengthValidator } from '@/uikit/forms/validators';

export const informationLayout: IFormLayout = [
  [
    {
      path: 'name',
      classes: 'n-form-w-4 n-form-pad-10 control-m',
      i18n_label: 'common.name',
      component: NInput,
      validators: [{ name: 'required' }, getStringLengthValidator({ required: true, min: 1, max: 256 })],
      errorPlacements: ['left'],
      errorStyles: { maxWidth: '180px' }
    },
    {
      path: 'incident_date',
      classes: 'n-form-w-2 n-form-pad-10 n-form-ml-1 control-m n-form-cw-110',
      i18n_label: 'cases.incident_date',
      component: NDateInput,
      validators: [{ name: 'required' }],
      errorPlacements: ['right']
    }
  ],
  {
    path: 'comment',
    classes: 'n-form-w-520 n-form-pad-10 control-m',
    i18n_label: 'common.comment',
    component: NInput
  },
  [
    {
      path: 'record_id',
      classes: 'n-form-w-4 n-form-pad-10 control-m',
      i18n_label: 'cases.record_id',
      component: NInput,
    },
    {
      path: 'record_created_date',
      classes: 'n-form-w-2 n-form-pad-10 n-form-ml-1 control-m',
      i18n_label: 'cases.record_date',
      component: NDateInput,
    }
  ]
];

export const permissionsLayout: IFormLayout = [
  {
    path: 'permissions',
    classes: 'n-form-w-6',
    component: Permissions,
    props: {
      hasDelete: true,
      disabledIds: [1]
    }
  }
];
